import { Constants } from 'constants/constants'
import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchPayrollRGD = fetchGeneralData<any>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/${Constants.GREENFIELD_CARDS.ASSETS_PROTECTION.PAYROLL_RGD}`,
)
